import React, { JSX } from 'react';
import { OrderSaleTab } from '../type';
import styles from '../products.module.scss';
import LoadingView from '../common-views/loading';
import NoItemView from '../common-views/empty';
import NoSearchItemView from '../common-views/search-empty';

interface ProductWrapperProps {
  isLoading: boolean;
  currentTab: OrderSaleTab;
  isFilter: boolean;
  hasProducts: boolean;
  isSearchEmpty: boolean;
  children: JSX.Element;
}

const ProductWrapper: React.FCWithChildren<ProductWrapperProps> = ({
  isLoading,
  currentTab,
  isFilter,
  hasProducts,
  isSearchEmpty,
  children,
}) => {
  if (isLoading) {
    return (
      <LoadingView
        currentTab={currentTab}
        forTab={'Sale'}
        className={styles.ordersSales__mainLeft__customLoading}
      />
    );
  }

  if (!hasProducts && !isFilter) {
    return (
      <NoItemView
        currentTab={currentTab}
        forTab={'Sale'}
      />
    );
  }

  if (isSearchEmpty || (isFilter && !hasProducts)) {
    return <NoSearchItemView />;
  }

  return children;
};

export default ProductWrapper;
